// The Collection Store's three tabs, in display order.
export const COLLECTION_TABS = [
  { key: 'guardians', label: 'Guardians' },
  { key: 'relics', label: 'Relics' },
  { key: 'badges', label: 'Badges' },
];

export const DEFAULT_COLLECTION_TAB = 'guardians';
